import { api } from "api";
import RouterErrorBox from "components/RouterErrorBox";
import type { NonIndexRouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import artifactsRoute from "./artifacts";
import ForkRoute from "./ForkRoute";
import FaucetRoute from "./faucet";
import sdkRoute from "./sdk";
import FaucetStatusRoute from "./status";
import tasksRoute from "./tasks";
import { txRoute } from "./tx";
import updateRoute from "./update";

export const forkRoute: NonIndexRouteObject = {
  loader: ({ params }) => api.status(params.executionId),
  element: <ForkRoute />,
  errorElement: <RouterErrorBox />,
  children: [
    {
      index: true,
      element: <Navigate to="status" replace={true} />,
    },
    {
      path: "status",
      element: <FaucetStatusRoute />,
    },
    {
      path: "faucet",
      element: <FaucetRoute />,
      errorElement: <RouterErrorBox />,
    },
    {
      path: "artifacts",
      errorElement: <RouterErrorBox />,
      ...artifactsRoute,
    },
    {
      path: "update",
      id: "update",
      errorElement: <RouterErrorBox />,
      ...updateRoute,
    },
    {
      path: "sdk",
      id: "sdk",
      errorElement: <RouterErrorBox />,
      ...sdkRoute,
    },
    {
      path: "tasks",
      id: "tasks",
      errorElement: <RouterErrorBox />,
      ...tasksRoute,
    },
    {
      path: "tx/:txHash",
      ...txRoute,
    },
  ],
};
